import { render, staticRenderFns } from "./soccerLottery.vue?vue&type=template&id=4fae80b5&scoped=true&"
import script from "./soccerLottery.vue?vue&type=script&lang=js&"
export * from "./soccerLottery.vue?vue&type=script&lang=js&"
import style0 from "./soccerLottery.vue?vue&type=style&index=0&id=4fae80b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fae80b5",
  null
  
)

export default component.exports